import { render, staticRenderFns } from "./fenxiao_withdraw_list.vue?vue&type=template&id=b99ad8aa&scoped=true"
import script from "./fenxiao_withdraw_list.vue?vue&type=script&lang=js"
export * from "./fenxiao_withdraw_list.vue?vue&type=script&lang=js"
import style0 from "./fenxiao_withdraw_list.vue?vue&type=style&index=0&id=b99ad8aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99ad8aa",
  null
  
)

export default component.exports